import React from 'react';
import styled from 'styled-components';
import { useDateFormatter } from '@react-aria/i18n';
import { CalendarButton } from './CalendarButton';

const CalendarHeaderContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 12px;
`;

export function CalendarHeader({
    state,
    calendarProps,
    prevButtonProps,
    nextButtonProps,
}) {
    let monthDateFormatter = useDateFormatter({
        month: 'short',
        year: 'numeric',
        timeZone: state.timeZone,
    });

    return (
        <CalendarHeaderContainer>
            <CalendarButton {...prevButtonProps}>
                <i
                    style={{ cursor: 'pointer', padding: '4px' }}
                    className="fas fa-chevron-left"
                ></i>
            </CalendarButton>

            <p
                aria-hidden
                className="flex-1 align-center text-center"
            >
                {monthDateFormatter.format(
                    state.visibleRange.start.toDate(state.timeZone),
                )}
            </p>
            <p aria-hidden className="flex-1 align-center text-center">
                {monthDateFormatter.format(
                    state.visibleRange.start
                        .add({ months: 1 })
                        .toDate(state.timeZone),
                )}
            </p>
            <CalendarButton {...nextButtonProps}>
                <i
                    style={{ cursor: 'pointer', padding: '4px' }}
                    className="fas fa-chevron-right"
                ></i>
            </CalendarButton>
        </CalendarHeaderContainer>
    );
}
